import { TestimonialType } from "../interfaces/testimonial.interface";

export const Testimonials: Array<TestimonialType> = [
	{
		name: 'Razi L.',
		ageAndJob: '27, Engineer',
		testimonial: { text: 'I am addicted to SweatPals: Every day after work I check SweatPals to go out. I have lost 30 lbs and SweatPals has truly changed my life.' }
	},
	{
		name: 'Emily  M.',
		ageAndJob: '29, Data Analyst, Fitness Enthusiast',
		testimonial: { text: 'I just want to say I love this app so much and it has changed my life! I have never been so out and about in my community ocnnecting with like minded individuals. This has also inspired me to create my own business in wellness and nutrition. Thank you SweatPals!! ' },
	},
	{
		name: 'Morgan Z',
		ageAndJob: '24, Sales, Acroyoga & Climbing Enthusiast',
		testimonial: { text: 'I met my boyfriend from one of Acroyoga groups on SweatPals! Not exactly a dating app but this thing works!! Such a non-intimidating way of meeting people who are into the same thing. I learned Acroyoga (and a bunch of other new activities), got my workouts done, met so many amazing people, and got a relationship out of it lol. 10/10!!' },
	},
	{
		name: 'Jesse Ruiz',
		ageAndJob: 'Running Coach, \n' +
			'SweatPals Ambassador, Lululemon Ambassador',
		testimonial: { videoSrc: '/assets/about/video/jesse_r.webm' },
	},
	{
		name: 'Isa  S.',
		ageAndJob: '22, Ballet Dancer',
		testimonial: { text: 'I love this app! So many cute features and super easy to use. I think my favorite feature is the journal entry’s. I love seeing my progress and being inspired by other people. Definitely recommend if you like working out and making new friends. They have loads of workout groups on there to check out and almost all the workouts are free!!' },
	},
	{
		name: 'Sarah D. ',
		ageAndJob: '33, Teacher, SweatPals Ambassador',
		testimonial: { videoSrc: '/assets/about/video/sarah_d.webm' },
	},
	{
		name: 'Brian M.',
		ageAndJob: '29, Digital Nomads, Tech',
		testimonial: { text: 'I went to a SweatPals event every day for the 10 days I visited Austin and it convinced me to move here. What a brilliant idea and found so many awesome communities thanks to this app! ' },
	},
	{
		name: 'Jordan K.',
		ageAndJob: '25, QA Engineer',
		testimonial: { text: 'No one talks about how hard it is to make friends as an adult. Night life was never my scene and SweatPals really hits the spot for me. What a brilliant idea! It single-handedly changed my social life since I got on it. LOVE SWEATPALS! ' },
	},
	{
		name: 'Michael B.',
		ageAndJob: '33, Teacher, SweatPals Ambassador',
		testimonial: { videoSrc: '/assets/about/video/michael_b.webm' },
	},
	{
		name: 'Diana S.',
		ageAndJob: '27,  Architect, ',
		testimonial: { text: 'We are here for ACL festival in Austin for 2 weeks and everyone we talked to told us to download SweatPals to find fitness & wellness communities. So far we’ve gone to breathwork, yoga, running, sound bath, all for FREE. Legit the only place you can find all the wellness events and groups. I wish they were in Santa Monica!' },
	},
	{
		name: 'Danial G.',
		ageAndJob: 'Fitness Coach, Influencer, Podcaster, Founder of Warrior Women',
		testimonial: { videoSrc: 'assets/about/video/danial_g.webm' },
	},
	{
		name: 'Jenn K.',
		ageAndJob: '35, Public Relations Specialist',
		testimonial: { text: 'I love this app - As a new Austin resident, it\'s been such a great way to discover the local fitness scene, explore the city and most of all connect with awesome people. It\'s truly such a unique and welcoming community - totally recommend for anyone new to a city, looking to meet cool people, build community or try something new!' },
	},
	{
		name: 'Alex',
		ageAndJob: '35, UX Researcher',
		testimonial: { text: '"The best fitness community app out there. I\'ve met so many like-minded individuals and even joined a local running club!"' },
	},
	{
		name: 'Shayne C.',
		ageAndJob: 'Fitness Solopreneur, Founder of Back to Basic Breath',
		testimonial: { videoSrc: '/assets/about/video/shayne_c.webm' },
	},
	{
		name: 'Daniela B',
		ageAndJob: '26, Chemist, Researcher',
		testimonial: { text: 'I started using SweatPals last fall, tried shuffle dance, sound bath, pickle-ball, breath-work and 20 other things. There’s something about trying/unlocking new things that just got me hooked. So one day out of nowhere I just decided to sign up Morning Jo’s Run in downtown Austin- it’s kind of an iconic run club that has 150+ showing up each week. Oh man running with a group is a whole different game. I died at the first run but running & chatting with people in the same pace made it so much more doable. I joined 3 other run groups since then, and today I just signed up for a HALF MARATHON!! I’m SO NERVOUS but at least I have I got my Sweat Pals running with me who are also first timers. I honestly would never thought I was gonna do a half-marathon. Thank you SweatPals, you opened up a whole new world to me. ' },
	},
	{
		name: 'Aditya D.',
		ageAndJob: '24, Project Manager',
		testimonial: { text: 'This app is a game changer! I moved to Austin a month ago and have already met so many cool people and groups through SweatPals! I love how you can journal your workouts in the app too. It’s different from the social media apps - the pics/photos people share here are so unfiltered and natural, which makes it super low pressure to share things. It’s quite motivating to browse through everyone’s workout journals.' },
	},
	{
		name: 'Ellie R.',
		ageAndJob: '32, Founder of Comfort Zone Retreat, Emotional Eating Coach',
		testimonial: { videoSrc: '/assets/about/video/ellie_r.webm' },
	},
	{
		name: 'Melissa K.',
		ageAndJob: '27,  Designer ',
		testimonial: { text: 'I recently discovered the SweatPals app and have been loving it. I was hesitant to try group fitness classes before, but found some walking groups on the app that seemed approachable. It\'s been a great way to get some easy cardio in while also making new friends. The app is easy to use and the community is really welcoming. I\'ve even started playing pickleball because of SweatPals. I\'d definitely recommend giving it a try!' },
	},
	{
		name: 'Mitchell L.',
		ageAndJob: '25, Influencer, Runner',
		testimonial: { text: 'Think strava but free and you can literally find like-minded individuals in whatever athletic focus you may lean towards. If you’re a runner there’s groups for that, if you’re into yoga there are groups for that. Heck if you like to dance for your workout guess what? There’s a group for that on this app! Etc. That is what makes SweatPals a game changer compared to strava or any fitness app on the market. Inclusivity and friendship, what could be better? I highly recommend this app and love it! 5 stars!!!!' },
	},
	{
		name: 'Elenor L.',
		ageAndJob: 'Entrepreneur, Creator, Founder of Hot Girl Golf',
		testimonial: { videoSrc: '/assets/about/video/elenor_l.webm' },
	},
	{
		name: 'Mike R.',
		ageAndJob: '33, Carpenter',
		testimonial: { text: 'I can’t believe how much this app has helped me find the right event or community to workout with. I am new in Miami and I now have a way to find new SweatPal 😃' },
	},
	{
		name: 'PRERNA',
		ageAndJob: '31, Venture Partner, New to Austin',
		testimonial: { text: 'I usually don’t review apps but SweatPals has helped me meet so many cool people and clubs. If you like fitness and want to find clubs or friends or just track your progress, this app is a must!!' },
	},
];
